import React from 'react';
import * as styles from '../styles/popover.module.scss';

interface Props {
  type?: 'info' | 'warning' | 'danger';
  message: string;
  title: string;
}
const Popover: React.FC<Props> = ({ type, message, title }) => (
  <div
    className={(() => {
      switch (type) {
        case 'warning':
          return styles.bottom_notification_warning;
        case 'danger':
          return styles.bottom_notification_danger;
        case 'info':
        default:
          return styles.bottom_notification_info;
      }
    })()}
  >
    <div className={styles.notification_text}>
      <span className={styles.notification_title}>{title}</span>
      <span>{message}</span>
    </div>
  </div>
);

export default Popover;
